<template>
  <div>
    <Parallax
      :pageInfo="this.pageInfo"
      :info="this.getInfo"
      :updateInfo="updateParallax"
    />
    <!-- Albums -->
    <v-sheet class="mx-auto" color="#fffff">
      <dialogAlbum action="Add" @add="addAlbum($event)" />
      <v-layout justify-center>
        <div
          class="d-flex d-sm-none d-md-none d-lg-none d-xl-none text-md-body-1"
          color="#D11724"
        >
          Photo Albums
        </div>
        <div
          class="d-none d-sm-flex d-md-none d-lg-none d-xl-none text-md-body-1 text-center "
          color="#D11724"
        >
          Photo Albums
        </div>
        <div
          class="d-none d-sm-none d-md-flex d-lg-none d-xl-none text-md-body-1 text-center "
          color="#D11724"
        >
          Photo Albums
        </div>
        <div
          class="d-none d-sm-none d-md-none d-lg-flex d-xl-none text-lg-h4 text-center "
          color="#D11724"
        >
          Photo Albums
        </div>
        <div
          class="d-none d-sm-none d-md-none d-lg-none d-xl-flex text-xl-h4 text-center "
          color="#D11724"
        >
          Photo Albums
        </div>
      </v-layout>
      <br />
      <v-slide-group>
        <template v-slot:next>
          <div>
            <v-icon large dark>mdi-chevron-right</v-icon>
          </div>
        </template>
        <template v-slot:prev>
          <div>
            <v-icon large dark>mdi-chevron-left</v-icon>
          </div>
        </template>
        <v-slide-item v-for="(album, key) in getAlbums" :key="key">
          <div>
            <div class="d-flex d-sm-none">
              <v-card class="ma-4" width="300" shaped>
                <dialogAlbum
                  action="Update"
                  :mydata="album"
                  @update="updateAlbum($event)"
                  @delete="deletingAlbum($event)"
                />
                <v-img
                  class="white--text align-end"
                  height="150px"
                  :src="album.Image_Link"
                ></v-img>
                <v-card-title
                  class="text-caption text-truncate"
                  color="#D1433F"
                  >{{ album.Title }}</v-card-title
                >
                <v-card-subtitle class="pb-0 text-truncate">{{
                  moment(String(album.Dated)).format("MMMM DD, YYYY")
                }}</v-card-subtitle>
                <v-card-actions>
                  <DViewImage :title="album.Title" :myData="album" />
                </v-card-actions>
              </v-card>
            </div>
            <div class="d-none d-sm-flex d-md-none">
              <v-card class="ma-4" width="300" height="350" shaped>
                <dialogAlbum
                  action="Update"
                  :mydata="album"
                  @update="updateAlbum($event)"
                  @delete="deletingAlbum($event)"
                />
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="album.Image_Link"
                ></v-img>
                <v-card-title
                  class="text-caption text-truncate"
                  color="#D1433F"
                  >{{ album.Title }}</v-card-title
                >
                <v-card-subtitle class="pb-0 text-truncate">{{
                  moment(String(album.Dated)).format("MMMM DD, YYYY")
                }}</v-card-subtitle>
                <v-card-actions>
                  <DViewImage :title="album.Title" :myData="album" />
                </v-card-actions>
              </v-card>
            </div>
            <div class="d-none d-md-flex">
              <v-card class="ma-4" width="400" height="350" shaped>
                <dialogAlbum
                  action="Update"
                  :mydata="album"
                  @update="updateAlbum($event)"
                  @delete="deletingAlbum($event)"
                />
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="album.Image_Link"
                ></v-img>
                <v-card-title class="text-truncate" color="#D1433F">{{
                  album.Title
                }}</v-card-title>
                <v-card-subtitle class="pb-0 text-truncate">{{
                  moment(String(album.Dated)).format("MMMM DD, YYYY")
                }}</v-card-subtitle>
                <v-card-actions>
                  <DViewImage :title="album.Title" :myData="album" />
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
      <br />
      <br />
    </v-sheet>
    <!-- Videos -->
    <v-sheet class="mx-auto" color="#d11724">
      <dialogVideo action="Add" @add="addVideo($event)" />
      <br />
      <v-slide-group>
        <template v-slot:next>
          <div>
            <v-icon large dark>mdi-chevron-right</v-icon>
          </div>
        </template>
        <template v-slot:prev>
          <div>
            <v-icon large dark>mdi-chevron-left</v-icon>
          </div>
        </template>
        <v-slide-item class="mx-1" v-for="(video, key) in getVideos" :key="key">
          <div>
            <div class="d-flex d-sm-none">
              <v-card class="ma-4" height="auto" width="auto">
                <v-card-content>
                  <youtube
                    player-width="auto"
                    player-height="auto"
                    :video-id="video.VideoId"
                  ></youtube>
                  <v-card-title
                    class="text-caption text-truncate"
                    color="#D1433F"
                    >{{ video.Title }}</v-card-title
                  >
                  <v-card-actions>
                    <dialogVideo
                      action="Update"
                      :mydata="video"
                      @delete="removeVideo($event)"
                      @update="updateVideo($event)"
                    />
                  </v-card-actions>
                </v-card-content>
              </v-card>
            </div>
            <div class="d-none d-sm-flex">
              <v-card class="ma-4" height="auto" width="auto">
                <v-card-content>
                  <youtube :video-id="video.VideoId"></youtube>
                  <v-card-title
                    class="text-display-1 text-truncate"
                    color="#D1433F"
                    >{{ video.Title }}</v-card-title
                  >
                  <v-card-actions>
                    <dialogVideo
                      action="Update"
                      :mydata="video"
                      @delete="removeVideo($event)"
                      @update="updateVideo($event)"
                    />
                  </v-card-actions>
                </v-card-content>
              </v-card>
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
      <br />
      <br />
    </v-sheet>
    <Footer />
  </div>
</template>

<script>
import Footer from "../Footer";
import Parallax from "../../components/global/parallax";
import DViewImage from "../../components/global/dialogs/dialog_view_images";
import dialogAlbum from "../../components/global/dialogs/dialog_gallery_album";
import dialogVideo from "../../components/global/dialogs/dialog_gallery_video";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    Footer,
    Parallax,
    dialogAlbum,
    dialogVideo,
    DViewImage
  },
  computed: {
    ...mapGetters("global", ["getWebInfo", "getArea"]),
    ...mapGetters("gallery", ["getInfo", "getAlbums", "getVideos"])
  },
  data: () => ({
    index: null,
    pageInfo: {
      title: "Gallery",
      subTitle: "Learn more about us"
    }
  }),
  methods: {
    ...mapActions("gallery", [
      "initialized",
      "putParallax",
      "postAlbum",
      "putAlbum",
      "deleteAlbum",
      "postVideo",
      "putVideo",
      "deleteVideo"
    ]),
    moment,
    async initializedInfo() {
      try {
        await this.initialized();
      } catch (error) {
        console.log(error);
      }
    },
    async updateParallax(data) {
      try {
        await this.putParallax(data);
      } catch (error) {
        console.log(error);
      }
    },
    async addAlbum(data) {
      try {
        await this.postAlbum(data);
      } catch (error) {
        console.log(error);
      }
    },
    async updateAlbum(data) {
      try {
        await this.putAlbum(data);
      } catch (error) {
        console.log(error);
      }
    },
    async deletingAlbum(data) {
      try {
        await this.deleteAlbum(data);
      } catch (error) {
        console.log(error);
      }
    },
    async addVideo(data) {
      try {
        await this.postVideo(data);
      } catch (error) {
        console.log(error);
      }
    },
    async updateVideo(data) {
      try {
        await this.putVideo(data);
      } catch (error) {
        console.log(error);
      }
    },
    async removeVideo(data) {
      try {
        await this.deleteVideo(data);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.initializedInfo();
  }
};
</script>

<style lang="scss" scoped>
</style>